export default __webpack_public_path__ + "static/media/general-information.fa5c7d83.svg";